var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutozoneProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f57f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#f58226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f55826"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.37653,48.17163l16.11835-9.30554c.78961-.45587.78961-1.59558,0-2.05145l-5.6098-3.23877-18.48676,10.67346,6.79382,3.9223c.36646.21155.81793.21155,1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.19238,27.50885l-16.11823,9.30585c-.78955.45587-.78955,1.59558.00006,2.05145l5.13184,2.96277,18.48712-10.67334-6.31641-3.64673c-.36646-.21155-.81793-.21155-1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.20178,62.15289c0,.41125.21936.7912.5755.99683l16.18445,9.34412c.76733.44305,1.72656-.11072,1.72656-.99683v-18.68817c0-.41119-.21942-.7912-.5755-.99677l-6.87177-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.76733-.44305-1.7265.11072-1.7265.99677v18.68835Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.28381 65.49896 52.14648 65.49896 59.12823 53.3548 54.26178 53.3548 47.28381 65.49896"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.91333 65.49896 62.36047 65.49896 64.87677 61.13458 69.34229 53.3548 67.89325 53.3548 60.91333 65.49896"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "64.74121 65.49896 71.71918 53.3548 70.86578 53.3548 63.88782 65.49896 64.74121 65.49896"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "73.38782 53.3548 66.40979 65.49896 66.8222 65.49896 73.79828 53.3548 73.38782 53.3548"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.38519 65.49896 59.72394 65.49896 66.71149 53.3548 64.367 53.3548 57.38519 65.49896"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.5155 53.3548 59.83655 53.3548 52.85858 65.49896 56.5318 65.49896 63.5155 53.3548"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutozoneProductsScraper);
export default __webpack_public_path__ + "static/media/autozone-products-scraper.b5b1e7e066282909944c1d510a8ac652.svg";
export { ForwardRef as ReactComponent };